// extracted by mini-css-extract-plugin
module.exports = {"debugButton":"ParserDebugButton_debugButton__1moI9"};